import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

type Props = {
  open: boolean;
  onClose: (confirmed: boolean) => void;
};

export default function ResetUser2FADialog({ open, onClose }: Props) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={() => onClose(false)}>
      <DialogTitle>Reset user's two-factor authentication (2FA)</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
          This will disable 2FA and reset the authenticator key.
        </Typography>
        <Typography variant="body2">
          After this action, the user can sign in without 2FA. They will need to set up 2FA again to re-enable it.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(true)} color="error" variant="contained">Reset 2FA</Button>
        <Button onClick={() => onClose(false)} color="inherit" variant="text">Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
